module.exports = __webpack_public_path__ + "static/media/proj13_img2.a9481c65.jpg";